module.exports = __webpack_public_path__ + "img/8.03e83c08.png";